import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function FrameInspectIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12372_107409" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12372_107409)"><path d="M18.7433 22.9167C19.9144 22.9167 20.9028 22.5161 21.7083 21.715C22.5139 20.9136 22.9167 19.9275 22.9167 18.7567C22.9167 17.5856 22.5161 16.5972 21.715 15.7917C20.9136 14.9861 19.9275 14.5833 18.7567 14.5833C17.5856 14.5833 16.5972 14.9839 15.7917 15.785C14.9861 16.5864 14.5833 17.5725 14.5833 18.7433C14.5833 19.9144 14.9839 20.9028 15.785 21.7083C16.5864 22.5139 17.5725 22.9167 18.7433 22.9167ZM26.7917 28.5833L22.4583 24.25C21.8472 24.6389 21.2292 24.9306 20.6042 25.125C19.9792 25.3194 19.3676 25.4167 18.7696 25.4167C16.9232 25.4167 15.3472 24.7639 14.0417 23.4583C12.7361 22.1528 12.0833 20.5833 12.0833 18.75C12.0833 16.9167 12.7361 15.3472 14.0417 14.0417C15.3472 12.7361 16.9167 12.0833 18.75 12.0833C20.5833 12.0833 22.1528 12.7361 23.4583 14.0417C24.7639 15.3472 25.4167 16.9232 25.4167 18.7696C25.4167 19.3676 25.3125 19.9792 25.1042 20.6042C24.8958 21.2292 24.5972 21.8472 24.2083 22.4583L28.5833 26.8333L26.7917 28.5833ZM7.5 35C6.83333 35 6.25 34.75 5.75 34.25C5.25 33.75 5 33.1667 5 32.5V25.3333H7.5V32.5H14.6667V35H7.5ZM25.3333 35V32.5H32.5V25.3333H35V32.5C35 33.1667 34.75 33.75 34.25 34.25C33.75 34.75 33.1667 35 32.5 35H25.3333ZM5 14.6667V7.5C5 6.83333 5.25 6.25 5.75 5.75C6.25 5.25 6.83333 5 7.5 5H14.6667V7.5H7.5V14.6667H5ZM32.5 14.6667V7.5H25.3333V5H32.5C33.1667 5 33.75 5.25 34.25 5.75C34.75 6.25 35 6.83333 35 7.5V14.6667H32.5Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}